var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-group-view"},_vm._l((_vm.actions),function(action,i){return _c('div',{key:i,class:{
		action: true,
		selected: _vm.value == action.value
	},domProps:{"innerHTML":_vm._s(action.label)},on:{"click":function($event){return _vm.onClick($event, action.value)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }